import { useEffect, useState } from "react";
import api, { eur, hrs } from "@/lib/apiClient";
import AdminLayout from "@/layouts/AdminLayout";
import { adminNav } from "@/lib/navConfig";
import { PageHeader, KpiCard } from "@/components/Common";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";

export default function CustomerProfitability() {
  const [customers, setCustomers] = useState([]);
  const [cid, setCid] = useState("");
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/customers").then((r) => { setCustomers(r.data); if (r.data[0]) setCid(r.data[0].id); }); }, []);
  useEffect(() => { if (cid) api.get(`/customers/${cid}/profitability`).then((r) => setData(r.data)); }, [cid]);
  const t = data?.totals;
  return (
    <AdminLayout nav={adminNav} title="Customer Profitability">
      <PageHeader title="Customer Profitability" subtitle="Aggregated across all customer sites" />
      <div className="max-w-xs mb-6">
        <Label>Customer</Label>
        <Select value={cid} onValueChange={setCid}>
          <SelectTrigger data-testid="cust-select" className="mt-1"><SelectValue /></SelectTrigger>
          <SelectContent>{customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {t && (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <KpiCard testId="cp-sites" label="Active Sites" value={data.active_sites} />
            <KpiCard testId="cp-revenue" label="Total Revenue" value={eur(t.total_revenue)} />
            <KpiCard testId="cp-profit" label="Gross Profit" value={eur(t.gross_profit)} accent />
            <KpiCard testId="cp-margin" label="Gross Margin" value={`${hrs(t.gross_margin_pct)}%`} accent />
          </div>
          <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto kqm-scroll">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-xs font-semibold uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
                <th className="p-3">Site</th><th className="p-3 text-right">Hours</th><th className="p-3 text-right">Revenue</th><th className="p-3 text-right">Cost</th><th className="p-3 text-right">Profit</th><th className="p-3 text-right">Margin</th>
              </tr></thead>
              <tbody>
                {data.sites.map((s) => (
                  <tr key={s.site.id} className="border-b border-zinc-50 hover:bg-zinc-50">
                    <td className="p-3 font-medium">{s.site.name}</td>
                    <td className="p-3 num text-right">{hrs(s.pnl.total_hours)}</td>
                    <td className="p-3 num text-right">{eur(s.pnl.total_revenue)}</td>
                    <td className="p-3 num text-right">{eur(s.pnl.total_cost)}</td>
                    <td className={`p-3 num text-right ${s.pnl.gross_profit < 0 ? "text-rose-600" : "text-emerald-600"}`}>{eur(s.pnl.gross_profit)}</td>
                    <td className="p-3 num text-right">{hrs(s.pnl.gross_margin_pct)}%</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </AdminLayout>
  );
}
